let inMemoryAccessToken = null;
let inMemoryAccessTokenExpiresAt = null;
let inMemoryRecoveryToken = null;
let inMemoryRecoveryTokenExpiresAt = null;
let refreshHandler = null;

export const getAccessToken = () => inMemoryAccessToken;

/** Absolute epoch-ms expiry of the in-memory token; lets peers prove a token isn't stale. */
export const getAccessTokenExpiry = () => inMemoryAccessTokenExpiresAt;

export const setAccessToken = (token, expiresAt = null) => {
  inMemoryAccessToken = token;
  inMemoryAccessTokenExpiresAt = expiresAt;
};

export const clearAccessToken = () => {
  inMemoryAccessToken = null;
  inMemoryAccessTokenExpiresAt = null;
};

export const getRecoveryToken = () => {
  if (inMemoryRecoveryTokenExpiresAt && Date.now() >= inMemoryRecoveryTokenExpiresAt) {
    clearRecoveryToken();
    return null;
  }
  return inMemoryRecoveryToken;
};

export const getRecoveryTokenExpiry = () => inMemoryRecoveryTokenExpiresAt;

export const setRecoveryToken = (token, expiresAt = null) => {
  inMemoryRecoveryToken = token;
  inMemoryRecoveryTokenExpiresAt = expiresAt;
};

export const clearRecoveryToken = () => {
  inMemoryRecoveryToken = null;
  inMemoryRecoveryTokenExpiresAt = null;
};

/** Reads csrf_token from document.cookie */
export const getCsrfToken = () => {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

/** Registers the React-based refresh callback */
export const registerRefreshHandler = (handler) => {
  refreshHandler = handler;
};

/** Triggers the reactive refresh across interceptors */
export const triggerRefresh = async (newClientId = null) => {
  if (refreshHandler) {
    return await refreshHandler(newClientId);
  }
  throw new Error("Refresh handler not registered in tokenService");
};
